import React from "react";
import { FundsAppContext } from "@features/context";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Dashboard from "./parts/Dashboard/Dashboard";
import queryString from "query-string";

import * as style from "./StakingPageStyle.module.scss"

type Props = {
  children: React.ReactNode;
};

const StakingPageWrapper = ({ children }: Props) => (
  <div>
    <main className={style.stakingPage}>{children}</main>
  </div>
);

interface IStakingPage
  extends RouteComponentProps<{ subpage: string; action: string }> {}

const StakingPage = (props: IStakingPage) => {
  const { appLink } = React.useContext(FundsAppContext);
  let { currency } = queryString.parse(props.location.search);

  return (
    <StakingPageWrapper>
      <Dashboard
        location={props.location}
        history={props.history}
        currency={currency}
        appLink={appLink}
      />
    </StakingPageWrapper>
  );
};

export default withRouter(StakingPage);
